<template>
    <v-container fluid class="pa-1 ma-1">
        <v-row dense>
            <v-col>
                <v-card flat>
                    <v-card-title class="pt-2">
                        {{ $t('labels.experienceInRank') }}
                    </v-card-title>
                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">{{ $t('fields.rank') }}</th>
                                        <th class="text-left">{{ $t('labels.months2') }}</th>
                                        <th class="text-left">{{ $t('labels.days') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in items" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.durationMonths }} &nbsp; {{ $t('labels.months2') }}</td>
                                        <td>{{ item.durationdays }} &nbsp; {{ $t('labels.days') }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
export default {
    name: 'SeafarerExperienceInRank',
    components: {},
    data: function () {
        return {
            items: [],
        };
    },
    props: ['seafarer', 'reload'],
    computed: {},
    methods: {},
    watch: {
        reload: {
            handler: function () {
                if (this.reload == 'additional') {
                    this.$APICall('get', 'experience-in-ranks/' + this.seafarer.id, {}, (data, succes) => {
                        if (succes) {
                            this.items = data;
                        }
                    });
                }
            },
            deep: true,
        },
    },

    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$APICall('get', 'experience-in-ranks/' + this.seafarer.id, {}, (data, succes) => {
            if (succes) {
                this.items = data;
            }
        });
    },
};
</script>

<style scoped></style>
